import { Component } from 'react';
import { connect } from 'react-redux';

import { bindActionCreators, Dispatch } from 'redux';
import { setLayoutAction, SetLayoutAction } from 'store/actions/layoutActions';
import { Layout, LayoutItem, PortType, RootState, SwitchType, UserType } from 'types';
import { MapControlsInterface, MenuControlsInterface } from 'types/functions';
import { checkDifferent, clone } from 'utils/formHandlers';
import { translate } from 'utils/translate';
import { twclsx } from 'utils/twclsx';

import { Tooltip } from 'react-tooltip';
import { ShowMessageAction, showMessageAction } from 'store/actions/errorsActions';
import Icon from './Icon';
import { hasPermission } from 'utils/permission';

interface TagTabProps {
    layout: Layout;
    first: boolean;
    mapControls: MapControlsInterface;
    setLayoutAction: SetLayoutAction;
    section: string;
    openProfile: VoidFunction;
    closeMeatOcean: VoidFunction;
    showMessageAction: ShowMessageAction;
    openReplay: VoidFunction;
    menuControls: MenuControlsInterface;
    switchs: SwitchType;
    opend: number;
    port: PortType;
    user: UserType;
}

interface TagTabState {
    layout: Layout;
    section: LayoutItem;
    switchs: SwitchType;
}

class TagTab extends Component<TagTabProps, TagTabState> {
    constructor(props: TagTabProps) {
        super(props);
        this.state = {
            section: clone(props.layout.sections[props.section]),
            layout: clone(props.layout),
            switchs: clone(props.switchs),
        };
    }

    static getDerivedStateFromProps(props: TagTabProps, state: TagTabState) {
        if (checkDifferent(props.layout, state.layout)) {
            return {
                layout: clone(props.layout),
                section: clone(props.layout.sections[props.section]),
                switchs: clone(props.switchs),
            };
        }
        if (checkDifferent(props.switchs, state.switchs)) {
            return {
                switchs: clone(props.switchs),
            };
        }
        return null;
    }

    renderIcon = (state: boolean) => {
        switch (this.props.section) {
            case 'replay':
                return (
                    <Icon className={twclsx('w-6', 'h-6', state ? 'text-gray-500' : 'text-white')}>
                        <path d="M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3"></path>
                        <path d="M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3"></path>
                    </Icon>
                );
                case 'aiChat':
                    return (
                        <Icon className={twclsx('w-6', 'h-6', state ? 'text-gray-500' : 'text-white')}>
                            <path
                                d="M12 3
               C12 8 16 12 21 12
               C16 12 12 16 12 21
               C12 16 8 12 3 12
               C8 12 12 8 12 3Z"
                            />
                        </Icon>
                    );
            case 'chart':
                return (
                    <Icon className={twclsx('w-6', 'h-6', state ? 'text-gray-500' : 'text-white')}>
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M3 7l6 -3l6 3l6 -3v13l-6 3l-6 -3l-6 3v-13" />
                        <path d="M9 4v13" />
                        <path d="M15 7v13" />
                    </Icon>
                );
            case 'grid':
                return (
                    <Icon className={twclsx('w-6', 'h-6', state ? 'text-gray-500' : 'text-white')}>
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z" />
                        <path d="M3 10h18" />
                        <path d="M10 3v18" />
                    </Icon>
                );
            case 'profile':
                return (
                    <Icon className={twclsx('w-6', 'h-6', state ? 'text-gray-500' : 'text-white')}>
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M3 3v18h18" />
                        <path d="M9 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                        <path d="M13 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                        <path d="M18 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                        <path d="M21 3l-6 1.5" />
                        <path d="M14.113 6.65l2.771 3.695" />
                        <path d="M16 12.5l-5 2" />
                    </Icon>
                );
            case 'playback':
                return (
                    <Icon className={twclsx('w-6', 'h-6', state ? 'text-gray-500' : 'text-white')}>
                        <path d="M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3"></path>
                        <path d="M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3"></path>
                    </Icon>
                );
            case 'time':
                return (
                    <Icon className={twclsx('w-6', 'h-6', state ? 'text-gray-500' : 'text-white')}>
                        <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
                        <path d="M12 12l3 -2"></path>
                        <path d="M12 7v5"></path>
                    </Icon>
                );
            case 'metOceanChart':
                return (
                    <Icon className={twclsx('w-6', 'h-6', state ? 'text-gray-500' : 'text-white')}>
                        <path d="M10 3.2a9 9 0 1 0 10.8 10.8a1 1 0 0 0 -1 -1h-3.8a4.1 4.1 0 1 1 -5 -5v-4a.9 .9 0 0 0 -1 -.8"></path>
                        <path d="M15 3.5a9 9 0 0 1 5.5 5.5h-4.5a9 9 0 0 0 -1 -1v-4.5"></path>
                    </Icon>
                );
            case 'tagsManager':
                return (
                    <Icon className={twclsx('w-6', 'h-6', state ? 'text-gray-500' : 'text-white')}>
                        <path d="M3 8v4.172a2 2 0 0 0 .586 1.414l5.71 5.71a2.41 2.41 0 0 0 3.408 0l3.592 -3.592a2.41 2.41 0 0 0 0 -3.408l-5.71 -5.71a2 2 0 0 0 -1.414 -.586h-4.172a2 2 0 0 0 -2 2z" />
                        <path d="M18 19l1.592 -1.592a4.82 4.82 0 0 0 0 -6.816l-4.592 -4.592" />
                        <path d="M7 10h-.01" />
                    </Icon>
                );
            case 'portsManager':
                return (
                    <Icon className={twclsx('w-6', 'h-6', state ? 'text-gray-500' : 'text-white')}>
                        <path d="M3 8v4.172a2 2 0 0 0 .586 1.414l5.71 5.71a2.41 2.41 0 0 0 3.408 0l3.592 -3.592a2.41 2.41 0 0 0 0 -3.408l-5.71 -5.71a2 2 0 0 0 -1.414 -.586h-4.172a2 2 0 0 0 -2 2z" />
                        <path d="M18 19l1.592 -1.592a4.82 4.82 0 0 0 0 -6.816l-4.592 -4.592" />
                        <path d="M7 10h-.01" />
                    </Icon>
                );
            case 'searchesManager':
                return (
                    <Icon className={twclsx('w-6', 'h-6', state ? 'text-gray-500' : 'text-white')}>
                        <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                        <path d="M21 21l-6 -6" />
                    </Icon>
                );
            case 'commentsManager':
                return (
                    <Icon className={twclsx('w-6', 'h-6', state ? 'text-gray-500' : 'text-white')}>
                        <path d="M3 20l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c3.255 2.777 3.695 7.266 1.029 10.501c-2.666 3.235 -7.615 4.215 -11.574 2.293l-4.7 1" />
                    </Icon>
                );
            case 'usersManager':
                return (
                    <Icon className={twclsx('w-6', 'h-6', state ? 'text-gray-500' : 'text-white')}>
                        <path d="M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
                        <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                        <path d="M21 21v-2a4 4 0 0 0 -3 -3.85" />
                    </Icon>
                );
            default:
                return null;
        }
    };

    getText = () => {
        switch (this.props.section) {
            case 'metOceanChart':
                return translate('metOcean informations', { key: this.state.section.data?.key });
            case 'playback':
                return translate('replay ais for', {
                    vesselName: this.state.layout.sections.playback.data?.transit?.vessel?.name,
                    date: this.state.layout.sections.playback.data?.transit?.start_utc.formatDateTimeToString('dd MMM'),
                });
            case 'time':
                return translate('replay ais at', {
                    date: this.state.layout.sections.time?.data?.startTime
                        ? `${this.state.layout.sections.time?.data?.startTime?.formatDateTimeToString(
                            'dd MMM'
                        )} to ${this.state.layout.sections.time?.data?.endTime?.formatDateTimeToString(
                            this.state.layout.sections.time?.data?.startTime?.formatDateTimeToString('dd MMM') ===
                                this.state.layout.sections.time?.data?.endTime?.formatDateTimeToString('dd MMM')
                                ? 'HH:mm'
                                : 'dd MMM'
                        )}`
                        : translate('AIS at any time'),
                });
            case 'replay':
                if (
                    this.state.layout.sections.time.time === this.state.layout.sections.playback.time &&
                    this.state.layout.viewMode === 'live'
                ) {
                    return translate('AIS at any time');
                } else if (
                    this.state.layout.sections.time.time > this.state.layout.sections.playback.time &&
                    this.state.layout.sections.time?.data?.startTime
                ) {
                    return translate('AIS to', {
                        word: translate('to_'),
                        date: this.state.layout.sections.time?.data?.startTime
                            ? `${this.state.layout.sections.time?.data?.endTime?.formatDateTimeToString(
                                'dd MMM HH:mm'
                            )}`
                            : translate('AIS', { word: translate('at_'), date: translate('any time') }),
                    });
                } else if (
                    this.state.layout.sections.time.time < this.state.layout.sections.playback.time &&
                    this.state.layout.sections.playback.data.transit?.start_utc
                ) {
                    return translate('replay ais for', {
                        vesselName: this.state.layout.sections.playback.data?.transit?.vessel?.name,
                        date: this.state.layout.sections.playback.data.transit?.start_utc.formatDateTimeToString(
                            'dd MMM'
                        ),
                    });
                } else {
                    return translate(this.state.section.description);
                }

            default:
                return translate(this.state.section.description);
        }
    };

    onClick = () => {
        this.props.showMessageAction({
            messageType: 'CLOSE',
        });
        if (this.state.section.disable && this.props.section !== 'profile' && this.props.section !== 'replay') {
            return;
        }

        if (this.props.section === 'profile') {
            this.props.openProfile();
            return;
        }

        if (this.props.section === 'replay') {
            this.props.openReplay();
            return;
        }

        // this.props.mapControls.chart?.hideTooltips();
        this.props.setLayoutAction([
            {
                action: 'UPDATE_SECTION',
                data: { name: this.props.section, state: true, display: true, disable: false },
            },
        ]);
    };

    closeReplay = () => {
        if (this.state.layout.viewMode !== 'live') {
            if (this.props.section === 'replay') {
                this.props.mapControls.playback?.closePlaybackMode();
            }
            if (this.props.section === 'time') {
                this.props.mapControls.time?.closeTimeMode();
            }

            this.props.setLayoutAction([
                {
                    action: 'UPDATE_SECTION',
                    data: { name: 'chart', state: true, display: true, disable: false },
                },
            ]);
        } else {
            // if (this.state.layout.sections.time.state) {
            //     this.props.mapControls.time?.clearTooltips();
            //     this.props.menuControls.time?.refresh(true, true);
            // } else {
            //     this.props.setLayoutAction([
            //         {
            //             action: 'UPDATE_SECTION',
            //             data: { name: 'time', state: true, display: false, disable: false, data: {} },
            //         },
            //     ]);
            // }
            this.props.setLayoutAction([
                {
                    action: 'UPDATE_SECTION',
                    data: { name: 'time', state: true, display: false, disable: false, data: {} },
                },
            ]);
            this.props.mapControls.time?.clearTooltips();
            this.props.menuControls.time?.refresh(true, true);
        }
    };

    render() {
        // if (
        //     this.props.section === 'replay' &&
        //     this.state.layout.viewMode !== 'chart' &&
        //     this.state.layout.viewMode !== 'grid'
        // ) {
        //     return;
        // }
        if (this.props.section === 'time') {
            return;
        }
        if (this.props.section === 'playback') {
            return;
        }
        const text = this.getText();
        return (
            <div
                className={twclsx(
                    this.state.section.state && 'bg-primary-activeTab  ',
                    this.state.section.disable && 'bg-primary-systemSecondary',
                    this.state.section.loading &&
                    (this.state.section.state ||
                        (this.props.section === 'replay' &&
                            (this.state.layout.sections.time.state ||
                                this.state.layout.sections.playback.state))) &&
                    'flash-tab',
                    this.props.section === 'replay' &&
                    (this.state.layout.sections.time.state || this.state.layout.sections.playback.state) &&
                    'bg-primary-activeTab ',
                    'cursor-pointer',
                    // !this.state.section.disable && ' hover:bg-gray-100 ',
                    this.state.section.disable && ' text-gray-400 ',
                    'relative',
                    ' h-14',
                    'flex',
                    'justify-start',
                    'items-center',
                    'pr-1',
                    ['tagsManager', 'portsManager', 'searchesManager', 'commentsManager', 'usersManager'].includes(
                        this.props.section
                    ) && this.props.opend >= 7
                        ? 'w-fit'
                        : [
                            'tagsManager',
                            'portsManager',
                            'searchesManager',
                            'commentsManager',
                            'usersManager',
                        ].includes(this.props.section)
                            ? 'sm:w-fit xl:w-48'
                            : 'w-48'
                )}
            >
                {!this.props.first && <div className="w-separator h-8 bg-primary-systemSecondary"></div>}
                <div onClick={this.onClick} className="flex justify-start items-center w-full z-10">
                    <div>
                        <div className="w-8 h-8 flex justify-center items-center ml-1 ">
                            {this.renderIcon(
                                (this.props.section === 'replay' &&
                                    (this.state.layout.sections.time.state ||
                                        this.state.layout.sections.playback.state)) ||
                                this.state.section.state
                            )}
                        </div>
                    </div>
                    <div>
                        <div
                            className={twclsx(
                                'truncate',
                                'text-gray-100',
                                this.state.section.state && 'text-blue-500',
                                this.props.section === 'replay' &&
                                (this.state.layout.sections.time.state ||
                                    this.state.layout.sections.playback.state) &&
                                'text-blue-500',
                                [
                                    'tagsManager',
                                    'portsManager',
                                    'searchesManager',
                                    'commentsManager',
                                    'usersManager',
                                ].includes(this.props.section) && this.props.opend >= 7
                                    ? 'hidden'
                                    : [
                                        'tagsManager',
                                        'portsManager',
                                        'searchesManager',
                                        'commentsManager',
                                        'usersManager',
                                    ].includes(this.props.section)
                                        ? 'sm:hidden  xl:block'
                                        : 'block'
                            )}
                        >
                            {translate(this.state.section.label)}
                        </div>
                        <div
                            data-tooltip-id={
                                this.props.section === 'replay' || this.props.section === 'playback'
                                    ? 'replayText'
                                    : 'noTooltip'
                            }
                            className={twclsx(
                                (!this.state.switchs.identifyTransits.value ||
                                    !hasPermission(this.props.user, this.props.port.id, ['identifyTransits'])) &&
                                    (this.props.section === 'replay' || this.props.section === 'playback') &&
                                 'blurText',
                                'text-sm',
                                'truncate',
                                'first-letter-uppercase',
                                'w-36',
                                'text-gray-500',
                                [
                                    'tagsManager',
                                    'portsManager',
                                    'searchesManager',
                                    'commentsManager',
                                    'usersManager',
                                ].includes(this.props.section) && this.props.opend >= 7
                                    ? 'hidden'
                                    : [
                                        'tagsManager',
                                        'portsManager',
                                        'searchesManager',
                                        'commentsManager',
                                        'usersManager',
                                    ].includes(this.props.section)
                                        ? 'sm:hidden  xl:block'
                                        : 'block'
                            )}
                        >
                            {text}
                        </div>
                    </div>
                    {this.state.switchs.identifyTransits.value &&
                        hasPermission(this.props.user, this.props.port.id, ['identifyTransits']) &&
                        (this.props.section === 'replay' || this.props.section === 'playback') && (
                            <Tooltip className="z-60" id="replayText" html={text} place={'left'} />
                        )}
                </div>
                {this.props.section === 'replay' && !this.state.section.disable && (
                    <div
                        data-tooltip-id="backToTimeMode"
                        onClick={this.closeReplay}
                        className="absolute z-20 top-1 right-1"
                    >
                        {this.props.layout.viewMode === 'live' ? (
                            <>
                                <Icon
                                    className={twclsx(
                                        'w-5',
                                        'h-5',
                                        this.props.section === 'replay' &&
                                            (this.state.layout.sections.time.state ||
                                                this.state.layout.sections.playback.state)
                                            ? 'text-gray-500'
                                            : 'text-white'
                                    )}
                                >
                                    <path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                                    <path d="M16.616 13.924a5 5 0 1 0 -9.23 0" />
                                    <path d="M20.307 15.469a9 9 0 1 0 -16.615 0" />
                                    <path d="M9 21l3 -9l3 9" />
                                    <path d="M10 19h4" />
                                </Icon>
                                <Tooltip
                                    className="z-40"
                                    id="backToTimeMode"
                                    html={translate('Latest AIS')}
                                    place={'right'}
                                />
                            </>
                        ) : (
                            <>
                                <Icon className="w-4 h-4 text-gray-500  ">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                    <path d="M18 6l-12 12"></path>
                                    <path d="M6 6l12 12"></path>
                                </Icon>
                                <Tooltip
                                    className="z-40"
                                    id="backToTimeMode"
                                    html={translate('Close')}
                                    place={'right'}
                                />
                            </>
                        )}
                    </div>
                )}

                {this.state.section.temp && (
                    <div
                        onClick={() => {
                            this.props.mapControls.chart?.hideTooltips();
                            if (this.props.section === 'metOceanChart') {
                                this.props.closeMeatOcean();
                                return;
                            }
                            this.props.setLayoutAction([
                                {
                                    action: 'CLOSE_SECTION',
                                    data: { name: this.props.section, state: false, display: false },
                                },
                            ]);
                        }}
                        className="absolute z-20 top-1 right-1"
                    >
                        <Icon
                            className={twclsx(
                                [
                                    'tagsManager',
                                    'portsManager',
                                    'searchesManager',
                                    'commentsManager',
                                    'usersManager',
                                ].includes(this.props.section) && this.props.opend >= 7
                                    ? 'h-4 w-4'
                                    : [
                                        'tagsManager',
                                        'portsManager',
                                        'searchesManager',
                                        'commentsManager',
                                        'usersManager',
                                    ].includes(this.props.section)
                                        ? 'sm:h-3 xl:h-4 sm:w-3 xl:w-4'
                                        : 'h-4 w-4',
                                'text-gray-500'
                            )}
                        >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                            <path d="M18 6l-12 12"></path>
                            <path d="M6 6l12 12"></path>
                        </Icon>
                    </div>
                )}

                {this.state.section.state && <div className="active-menu"></div>}
                {this.props.section === 'replay' &&
                    (this.state.layout.sections.time.state || this.state.layout.sections.playback.state) && (
                        <div className="active-menu"></div>
                    )}
            </div>
        );
    }
}

const tagTabStateToProps = (state: RootState) => ({
    layout: state.layout.layout,
    mapControls: state.map.mapControls,
    menuControls: state.layout.menuControls,
    switchs: state.layout.switchs,
    user: state.user.user,
    port: state.port.port,
});

const tagTabDispatchToProps = (dispatch: Dispatch) => ({
    setLayoutAction: bindActionCreators(setLayoutAction, dispatch),
    showMessageAction: bindActionCreators(showMessageAction, dispatch),
});

export default connect(tagTabStateToProps, tagTabDispatchToProps)(TagTab);
